(function () {
    'use strict';

    angular
        .module('ib-ancillaries-seats-module')
        .controller('AncillariesSeatsController', AncillariesSeatsController);

    AncillariesSeatsController.$inject = ['$rootScope', '$scope', 'localStorageService', 'DatalayerUtilsService', 'DatalayerMenusService'];
    function AncillariesSeatsController ($rootScope, $scope, localStorageService, DatalayerUtilsService, DatalayerMenusService) {
        const vm = this;
        vm.deleteSeat = deleteSeat;

        /**
         * Delete seats of segment and basket
         * @param {String} segmentId Delete seats of segment selected on basket
         * @param {String} seat Seat type to delete on service
         */
        function deleteSeat (segmentId, seat) {
            let deleteResponseInfo, segments = { type: 'SEAT', segments: [] }, trip = { id: null, passengers: [] }, i, counterSeats = 0, donationData;
            vm.basketFunctions.isLoading();
            DatalayerMenusService.deleteSeats(segmentId, seat);
            //$scope.$emit('deleteFees');
            angular.forEach(vm.model.segments, (segment) => {
                if (segment.segmentId === segmentId) {
                    trip.id = segmentId;
                    angular.forEach(segment.seats, (segmentSeat) => {
                        if (segmentSeat.type === seat.type) {
                            angular.forEach(seat.passengers, (pas) => {
                                if(pas.amount > 0) {
                                    trip.passengers.push(pas.id);
                                }
                                counterSeats += 1;
                            });
                        }
                    });
                    segments.segments.push(trip);
                }
            });

            vm.basketFunctions.deleteAncillariesService.deleteAncillarie([segments]).then((response) => {
                deleteSeatsSuccess();
                if (response.ancillaries.length > 0) {
                    deleteResponseInfo = response.ancillaries;
                } else {
                    deleteResponseInfo = [segments];
                }
                $rootScope.$broadcast('deleteSeats', { amount: counterSeats, seats: deleteResponseInfo });
                donationData = localStorageService.get('donation');
                if (donationData) {
                    $rootScope.$broadcast('checkDonation', true, donationData.option, donationData.donationInfo, donationData.form ? donationData.form.acceptDonationData : null, donationData.form ? donationData.form : null);
                }
                vm.basketFunctions.calculateAllBasket( '/' + localStorageService.get('actualStepFlow'));
                vm.basketFunctions.saveHeaderModel();
                deleteSelectedSeat(segmentId, seat);
                vm.basketFunctions.isNotLoading();
                DatalayerUtilsService.setAncillariesDatalayer();
                $rootScope.$broadcast('basketUpdateCommonHeader');
                
            }, (error) => {
                vm.basketFunctions.isNotLoading();
                vm.basketFunctions.modalService.setErrorMessage(error.message);
                vm.basketFunctions.modalService.setErrorCode(error.internalErrorCode);
                vm.basketFunctions.modalService.isError(error);
                vm.basketFunctions.collapseHeader.closeCollapse();
            });
            function calculateQuanty (segment) {
                let quanty = 0;
                angular.forEach(segment.seats,  (seat) => {
                    quanty += seat.freePassenger.length + seat.paymentPassenger.length;
                });
                return quanty;
            }
            function deleteSeatsSuccess () {
                let k, isFound = false, haveSeats = false;
                for (i = 0; i < vm.model.segments.length; i++) {
                    if (vm.model.segments[i].segmentId === segmentId) {
                        k = 0;
                        while (k < vm.model.segments[i].seats.length && !isFound) {
                            if (vm.model.segments[i].seats[k].type === seat.type) {
                                vm.model.segments[i].total = vm.model.segments[i].total - seat.amount;
                                vm.model.segments[i].totalFormatted = vm.basketFunctions.CurrencyService.formatPrice(vm.model.currency, vm.model.segments[i].total, true);
                                vm.model.segments[i].quanty = calculateQuanty(vm.model.segments[i]) - trip.passengers.length;
                                vm.model.segments[i].seats[k].paymentPassenger = [];
                                vm.model.segments[i].seats[k].passengers = vm.model.segments[i].seats[k].freePassenger;
                                vm.model.segments[i].seats[k].totalAmountPaymentPassenger = 0;
                                isFound = true;
                            }
                            k++;
                        }
                        vm.model.segments = checkSegmentSeats();
                        angular.forEach(vm.model.segments, (segment) => {
                            if (segment.seats.length > 0) {
                                haveSeats = true;
                            }
                        });
                        vm.model.hasSeats = haveSeats;
                    }
                }
            }

            function checkSegmentSeats () {
                const segments = [];
                if (vm.model.segments.length > 0) {
                    angular.forEach(vm.model.segments, (segment) => {
                        if (segment.quanty > 0) {
                            segments.push(segment);
                        }
                    });
                }
                return segments;
            }

            function deleteSelectedSeat (segmentId, seat) {
                const seatsSelectedInfoData = localStorageService.get('seatsSelectedInfoData'), flag = false;
                angular.forEach(seatsSelectedInfoData, (segment) => {
                    if (segmentId === segment.id) {
                        angular.forEach(segment.passengers, (passenger, index) => {
                            if ((seat.passengers.length > 0) && passenger.id === seat.passengers[0].id && passenger.seatType === seat.type) {
                                seatsSelectedInfoData[segment.id].passengers.splice(index, 1);
                            }
                        });
                    }
                });

                localStorageService.set('seatsSelectedInfoData', seatsSelectedInfoData);
            }
        }
    }
})();
